/* hcs-ship-order.js — live-order mode for the How Your Order Ships page.
   Renders per-shipment cards from window.hcsShipOrder (contract documented
   in sections/hcs-ship-journeys.liquid) or from the built-in demo fixture
   when the URL carries ?ship-demo=1. Depends on window.hcsShipX, exported
   by hcs-ship-journeys.js; both load with defer in document order. */
(function () {
  if (window.hcsShipOrderInit) return;
  window.hcsShipOrderInit = true;

  var SX = window.hcsShipX;
  if (!SX || !SX.root) return;
  var root = SX.root;

  // DONE = stages already true; CURRENT = the bolded "you are here" node.
  // created/subscribed: only "Ordered" is filled; "Shipped" is bolded but
  // hollow because the box has not actually moved yet.
  var STATUS_DONE = { created: 1, subscribed: 1, in_transit: 3, out_for_delivery: 4, delivered: 5, exception: 3 };
  var STATUS_CURRENT = { created: 1, subscribed: 1, in_transit: 2, out_for_delivery: 3, delivered: 4, exception: 2 };
  var STATUS_LABEL = {
    created: 'Preparing to ship',
    subscribed: 'Preparing to ship',
    in_transit: 'On its way',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
    exception: 'Needs a look'
  };
  var TYPE_LABEL = { frozen: 'Frozen', fresh: 'Fresh', pantry: 'Pantry' };
  var ORIGIN_LABEL = { NM: 'from the Hatch Valley, NM', NJ: 'from NJ cold storage', CA: 'from CA cold storage' };
  var CARRIER_LABEL = { ups: 'UPS', usps: 'USPS', fedex: 'FedEx', dhl: 'DHL', ontrac: 'OnTrac', lasership: 'LaserShip' };

  var DEMO_ORDER = {
    order: {
      name: '#48213',
      placedAt: '2026-07-20T15:04:00Z',
      shipments: [
        { type: 'frozen', status: 'in_transit', carrier: 'ups', trackingNumber: '1Z999AA10123456784',
          trackingUrl: 'https://www.ups.com/track?tracknum=1Z999AA10123456784',
          shipDate: '2026-07-22', currentEta: '2026-07-29', shouldArriveBy: '2026-07-27',
          lastScanAt: '2026-07-26T09:12:00Z',
          atRisk: { atRisk: true, reasons: ['stuck'], severity: 'amber' }, origin: 'NJ' },
        { type: 'pantry', status: 'delivered', carrier: 'usps', trackingNumber: '9400110200881234567890',
          trackingUrl: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=9400110200881234567890',
          shipDate: '2026-07-21', currentEta: null, shouldArriveBy: '2026-07-25',
          lastScanAt: '2026-07-24T18:40:00Z',
          atRisk: { atRisk: false, reasons: [], severity: null }, origin: 'NM' },
        { type: 'fresh', status: 'created', carrier: null, trackingNumber: null, trackingUrl: null,
          shipDate: '2026-07-29', currentEta: null, shouldArriveBy: null, lastScanAt: null,
          atRisk: { atRisk: false, reasons: [], severity: null }, origin: 'NM' }
      ]
    },
    preorderSchedule: null
  };

  function fmtISO(iso) {
    if (!iso) return null;
    // Date-only strings are calendar dates, not instants: format them
    // directly, or midnight UTC shifts them back a day in Mountain Time.
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return SX.formatHuman(iso);
    return SX.formatHuman(SX.isoDateInTZ(new Date(iso)));
  }

  function renderShipment(s, idx, total) {
    var esc = SX.escapeHtml;
    var type = TYPE_LABEL[s.type] ? s.type : 'pantry';
    var doneCount = STATUS_DONE[s.status] != null ? STATUS_DONE[s.status] : 1;
    var current = STATUS_CURRENT[s.status] != null ? STATUS_CURRENT[s.status] : 1;
    var label = STATUS_LABEL[s.status] || 'Preparing to ship';
    var stages = [
      { name: 'Ordered', date: null },
      { name: 'Shipped', date: fmtISO(s.shipDate) },
      { name: 'In transit', date: fmtISO(s.lastScanAt) },
      { name: 'Out for delivery', date: null },
      { name: 'Delivered', date: s.status === 'delivered' ? fmtISO(s.lastScanAt) : null }
    ];
    var html = '<article class="hcs-shipx__shipment" data-type="' + esc(type) + '">';
    html += '<span class="hcs-shipx__ship-type">' + esc(TYPE_LABEL[type]) + (total > 1 ? ' &middot; box ' + (idx + 1) + ' of ' + total : '') + '</span>';
    html += '<p class="hcs-shipx__ship-status">' + esc(label) + '</p>';

    var sub = '';
    if ((s.status === 'created' || s.status === 'subscribed') && !s.lastScanAt) {
      sub = s.shipDate
        ? 'Planned ship day: ' + esc(fmtISO(s.shipDate)) + '. Tracking starts at the first carrier scan.'
        : 'Label created. Waiting on the first carrier scan; short gaps are normal.';
    } else if (s.status === 'in_transit' && s.lastScanAt) {
      sub = 'Last scan ' + esc(fmtISO(s.lastScanAt)) + '. Carriers don\'t scan every stop.';
    } else if (s.status === 'out_for_delivery') {
      sub = 'On the truck for delivery today.';
    } else if (s.status === 'delivered') {
      sub = s.type === 'frozen' ? 'Get it into the freezer right away.' : (s.type === 'fresh' ? 'Spread the pods out and get them cool.' : 'Enjoy.');
    } else if (s.status === 'exception') {
      sub = 'The carrier reported a problem. We\'re watching it; you don\'t need to do anything yet.';
    }
    if (sub) html += '<p class="hcs-shipx__ship-sub">' + sub + '</p>';

    html += '<ol class="hcs-shipx__ministages">';
    for (var i = 0; i < stages.length; i++) {
      var attrs = '';
      if (i < doneCount) attrs += ' data-done';
      if (i === current) attrs += ' data-current';
      html += '<li class="hcs-shipx__ministage"' + attrs + '>' + esc(stages[i].name);
      if (stages[i].date) html += '<small>' + esc(stages[i].date) + '</small>';
      html += '</li>';
    }
    html += '</ol>';

    var eta = s.currentEta || s.shouldArriveBy;
    if (s.status !== 'delivered' && eta) {
      html += '<p class="hcs-shipx__ship-eta">Should arrive by <strong>' + esc(fmtISO(eta)) + '</strong></p>';
    }
    var carrier = s.carrier && CARRIER_LABEL[s.carrier] ? CARRIER_LABEL[s.carrier] : null;
    var url = typeof s.trackingUrl === 'string' && /^https:\/\//.test(s.trackingUrl) ? s.trackingUrl : null;
    if (url && carrier) {
      html += '<p class="hcs-shipx__ship-track"><a href="' + esc(url) + '" target="_blank" rel="noopener">Track with ' + esc(carrier) +
        '<span aria-hidden="true"> ↗</span><span class="visually-hidden"> (opens in a new tab)</span></a>' +
        (s.trackingNumber ? ' &middot; ' + esc(s.trackingNumber) : '') + '</p>';
    }
    if (s.origin && ORIGIN_LABEL[s.origin]) {
      html += '<p class="hcs-shipx__ship-origin">Shipped ' + esc(ORIGIN_LABEL[s.origin]) + '</p>';
    }

    if (s.atRisk && s.atRisk.atRisk) {
      var perishable = s.type === 'frozen' || s.type === 'fresh';
      var threshold = perishable ? '30 hours' : '2 full days';
      var sev = s.atRisk.severity === 'red' ? 'red' : 'amber';
      html += '<div class="hcs-shipx__ship-note" data-severity="' + sev + '" role="status">' +
        '<strong>Running behind.</strong> ' +
        (perishable ? 'The dry ice is sized to the transit time, so we watch these closely. ' : '') +
        'If tracking shows no movement for ' + threshold + ' past the expected window, <a href="/pages/contact-us">reach out</a> and we\'ll make it right. A quiet scan gap, especially over a weekend, is usually just the carrier not scanning.' +
        '</div>';
    }

    html += '</article>';
    return html;
  }

  var mount = root.querySelector('[data-sx-order]');
  if (!mount) return;
  var demo = /[?&]ship-demo=1(&|$)/.test(window.location.search);
  var data = window.hcsShipOrder || (demo ? DEMO_ORDER : null);
  if (!data || !data.order || !Array.isArray(data.order.shipments) || data.order.shipments.length === 0) return;

  var o = data.order;
  var html = '<div class="hcs-shipx__order-head">' +
    '<h2 class="hcs-shipx__order-name">Order ' + SX.escapeHtml(o.name || '') + '</h2>' +
    (o.placedAt ? '<p class="hcs-shipx__order-meta">Placed ' + SX.escapeHtml(fmtISO(o.placedAt)) + ' &middot; ' + o.shipments.length + (o.shipments.length === 1 ? ' shipment' : ' shipments') + '</p>' : '') +
    '</div>';
  if (o.shipments.length > 1) {
    html += '<p class="hcs-shipx__order-meta hcs-shipx__order-split">Your order ships as separate boxes on their own schedules. That\'s by design; see below.</p>';
  }
  html += '<div class="hcs-shipx__shipments">';
  for (var i = 0; i < o.shipments.length; i++) {
    html += renderShipment(o.shipments[i], i, o.shipments.length);
  }
  html += '</div>';
  mount.innerHTML = html;
  mount.hidden = false;

  // The evergreen rails stay on the page below the live view; they answer
  // the "why is it like this" questions the cards raise.
})();
